import { useCallback, useEffect, useRef, useState } from 'react';
export function useMultiSelectDropdown({ options, selectedValues = [], onChange, disabled = false, }) {
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');
    const dropdownRef = useRef(null);
    const selectedOptions = options.filter(option => selectedValues.includes(option.value));
    const isOptionSelected = useCallback((value) => {
        return selectedValues.includes(value);
    }, [selectedValues]);
    const handleOptionToggle = useCallback((optionValue) => {
        const isSelected = isOptionSelected(optionValue);
        let newSelectedValues;
        if (isSelected) {
            newSelectedValues = selectedValues.filter(value => value !== optionValue);
        }
        else {
            newSelectedValues = [...selectedValues, optionValue];
        }
        onChange(newSelectedValues);
    }, [selectedValues, onChange, isOptionSelected]);
    const handleSearchChange = useCallback((e) => {
        setSearchTerm(e.target.value);
    }, []);
    const toggleDropdown = useCallback(() => {
        if (disabled)
            return;
        setIsDropdownOpen(prev => !prev);
        if (!isDropdownOpen) {
            setSearchTerm('');
        }
    }, [disabled, isDropdownOpen]);
    const closeDropdown = useCallback(() => {
        setIsDropdownOpen(false);
        setSearchTerm('');
    }, []);
    useEffect(() => {
        const handleClickOutside = (event) => {
            const target = event.target;
            const targetElement = target instanceof Element ? target : null;
            if (targetElement?.closest('[data-ibk-outside-click-ignore="true"]'))
                return;
            if (dropdownRef.current && target && !dropdownRef.current.contains(target)) {
                closeDropdown();
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [closeDropdown]);
    const filteredOptions = useCallback(() => {
        if (!searchTerm) {
            return options;
        }
        return options.filter(option => option.label.toLowerCase().includes(searchTerm.toLowerCase()));
    }, [options, searchTerm]);
    const currentOptions = filteredOptions();
    const hasOptions = currentOptions.length > 0;
    return {
        isDropdownOpen,
        selectedOptions,
        filteredOptions: currentOptions,
        hasOptions,
        searchTerm,
        toggleDropdown,
        handleOptionToggle,
        handleSearchChange,
        closeDropdown,
        isOptionSelected,
        dropdownRef: dropdownRef,
    };
}
